module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAAAXNSR0IArs4c6QAAAQ1JREFUOE+llDFKBEEQRd87g5mhoewJBHEX880MNBRNBfEAuhcwUIxEQw028wLqHdbU0MwzlFPQA+s4y2xjwzDNUPPq96+qlrIi4go4BTbbbz3vmZpxv5ZLkNeyf+/5+RJ4a54xcK1eLMf8gaiTLiQamQWSCRL4oJ60cVWQTFCOnaBb9SxBVZCOwrGNQTWQO2D7X5Aej7IIw0oiYgYs1HlEHAA76nkCI2JtyAuwpY4iYgF8qtNaSPZEZkxFWY2Jmr2yvpIS/AQcAs/qUacxhz0pkG8gjzVVN6ohEXEDHAOjNBh4bJurxtgPYJ4DV7p0X92t9mTVNA8qaarQN8Vd3t6qZlvnPmlhX8B9e7f8ANuXuhJQpxIlAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/Icon/PorabaTelefonija/Icon-file-excel-regular.png
// module id = nVGm
// module chunks = 3